import { createHiveClient, type HiveClient } from '@hive/shared';
import { appEnv } from './env';

let client: HiveClient | undefined;

/** The app's one Supabase client. Only call after checking `appEnv.ok`. */
export function supabase(): HiveClient {
  if (!appEnv.ok) throw new Error(`Supabase is not configured: ${appEnv.problems.join(', ')}`);
  client ??= createHiveClient({
    url: appEnv.env.VITE_SUPABASE_URL,
    publishableKey: appEnv.env.VITE_SUPABASE_PUBLISHABLE_KEY,
  });
  return client;
}
